<template>
    <div class="albums">
        <h2 class="section-title">Discography</h2>
        <div class="albums-card">
            <!-- Heliography -->
            <div class="image-container">
                <div class="album-title">
                <h3>Heliography</h3>
                <h4>released May 26, 2023 </h4>
                <div class="button-container">
                    <a href="https://chaoticgoodrecords.square.site/product/isolation-tank-ensemble-heliography-2lp-vinyl/1" target="blank"><button class="action-button"><img src="../assets/bear-button.png" class="button-icon"><h4>Buy "Heliography" </h4></button></a>
                    <!-- <a href="https://chaoticgoodrecords.square.site/prheliographyoduct/isolation-tank-ensemble-heliography-2lp-vinyl/1" target="blank"><button class="action-button"><h4>Buy now</h4></button></a> -->
                </div>
                </div>
                <img src="../assets/heliography.jpg" class="album-image" alt="a woman desert monster rises from the dunes of an alien planet, with two burning suns scorching the sky.  The war mage stands before her, small, but ready for battle.">
                    <div class="p-container">
                        <p>
                            In an act of cosmic quantum entanglement, the twin suns delivered a heliographic message, flashing two breathing image-beings into existence on opposite sides of the land. One borne unto the Collapsers, immaculate in her conception. The other, angular and noisesome, borne as a scream made manifest unto the Mages. Once again, the world had its two avatars and this is their chronicle…
                        </p>
                        <p>
                            This record is a document of a pre-covid Isolation Tank Ensemble which began in February of 2020 and is only now, through the mists of time, finding its way into your sweaty little hands. Nick and Rye, without you this album would not be possible. We are so grateful for the crossing of our paths as life took us in different directions (aka a "barn fire"). We would like to thank Lamar Cornett for joining our group of weirdos.  
                        </p>
                    </div>
                    <div class="video-player">
                        <iframe width="auto" height="50%" src="https://www.youtube.com/embed/GRh1pzkg-Ag?si=Zy1oC7BNK9QWuYJo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                <h4>Produced by <a href="https://www.kincaidaudio.com/" target="blank"><button>Chris Kincaid</button></a></h4>
                <h4>Album art by <a href="https://angryblue.com/" target="blank"><button>Angry Blue</button></a> </h4>
        
            </div>
            <!-- La La Land -->
            <div class="image-container">
                <div class="album-title">
                <h3>Live at La La Land</h3>
                <h4>released February 21, 2022</h4>
                <div class="button-container">
                    <a href="https://isolationtankensemble1.bandcamp.com/album/live-at-la-la-land" target="blank" class="overflow-fix"><button class="action-button"><img src="../assets/bear-button.png" class="button-icon"><h4>Buy "Live at Lala Land" </h4></button></a>
                    <!-- <a href="https://isolationtankensemble1.bandcamp.com/album/live-at-la-la-land" target="blank" class="overflow-fix"><button class="action-button"><h4>Buy now</h4></button></a> -->
                </div>
                </div>
                <img src="../assets/lala-land.png" class="album-image">
                    <div class="p-container">
                        <p>
                            We gathered at La La Land Studio in Louisville, KY on February 21, 2022 to record 4 songs live. 
                        </p>
                        <p>
                            Randy Bayers filmed and edited the entire live performance and it can be viewed on Youtube. 
                        </p>
                    </div>
                    <div class="video-player">
                        <iframe width="auto" height="50%" src="https://www.youtube.com/embed/sX2vpdINoas?si=gCoNm_RznWU-_h3s" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                <h4>Recorded and mixed live at La La Land by <a href="https://www.annegauthier.info/studio" target="blank"><button>Anne Gauthier</button></a> </h4>
        
            </div>

            </div>
    </div>
</template>

<script>
    export default {
        name: 'AlbumsView',
        components: {
        }
    }
</script>


<style scoped>

.overflow-fix {
    padding-right: 0;
    padding-left: 0;
}

.albums {
    margin: auto;
}

.albums-card {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
}
.action-button {
    width: 80%;
}
.album-image {
    max-width: 500px;
    width: 80%;
}

.button-icon {
    width: 3em;
    padding-right: 2px;
}

.button-container {
    display: flex;
    flex-direction: column;
}

.image-container {
    border-bottom: 2px dotted #681012;
    max-width: 600px;
    text-align: center;
}

.album-title {
    text-align: center;
}

.p-container {
    text-align: left;
}


/* media queries */
@media only screen and (min-width: 500px) {
    .action-button {
        width: 45%;
    } 
}

</style>



